'use client'

import { useFormContext, useWatch } from 'react-hook-form'

import DeliveryIntervalInput from '@/components/Form/Atoms/DeliveryIntervalInput'
import PurchaseTypeRadioInput, { purchaseTypeRadioInputKey } from '@/components/Form/Atoms/PurchaseTypeRadioInput'
import { ProductType } from '@/types/product'

export {
  purchaseTypeRadioDefaultValue,
  purchaseTypeRadioInputKey,
} from '@/components/Form/Atoms/PurchaseTypeRadioInput'

export { deliveryIntervalDefaultValue, deliveryIntervalInputKey } from '@/components/Form/Atoms/DeliveryIntervalInput'

export default function PurchaseTypeInput({ product }: { product: ProductType }) {
  const { control } = useFormContext()

  const PurchaseType = useWatch({
    control,
    name: purchaseTypeRadioInputKey.name,
  })

  return (
    <>
      <PurchaseTypeRadioInput product={product} />
      {PurchaseType == 'subscription' && <DeliveryIntervalInput />}
    </>
  )
}
